
const PrivacyPolicy = () => {
    return (
        <div className="p-6 mx-auto  rounded-lg shadow-lg">
            <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">Privacy Policy</h1>
            <p className="text-center text-sm text-gray-500 mb-8">Effective Date: November 21, 2025</p>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Introduction</h2>
                <p className="text-lg text-gray-700">
                    At NassFoods, we value your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website, use our services, or interact with us in other ways. By using our services, you agree to the collection and use of information in accordance with this policy.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Information We Collect</h2>
                <p className="text-lg text-gray-700 mb-4">
                    We collect various types of information to provide and improve our services:
                </p>
                <ul className="list-disc pl-6 text-lg text-gray-700">
                    <li><strong>Personal Data:</strong> When you make a purchase, sign up for our newsletter, or contact us, we may collect personal information such as your name, email address, phone number, and shipping address.</li>
                    <li><strong>Usage Data:</strong> We may collect information about how our website is accessed and used, including your IP address, browser type, and pages visited.</li>
                    <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to track activity on our site and hold certain information.</li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">How We Use Your Information</h2>
                <p className="text-lg text-gray-700 mb-4">
                    We use the information we collect for various purposes, including:
                </p>
                <ul className="list-disc pl-6 text-lg text-gray-700">
                    <li>Providing and maintaining our services</li>
                    <li>Personalizing your experience and improving our website</li>
                    <li>Processing transactions and sending order updates</li>
                    <li>Sending promotional emails (with your consent)</li>
                    <li>Improving customer service</li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Security</h2>
                <p className="text-lg text-gray-700">
                    We are committed to protecting your personal information. We employ a variety of security measures, including encryption, to safeguard your data. However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Your Rights</h2>
                <p className="text-lg text-gray-700 mb-4">
                    You have certain rights regarding your personal data, including:
                </p>
                <ul className="list-disc pl-6 text-lg text-gray-700">
                    <li>The right to access your personal data</li>
                    <li>The right to correct or update your personal data</li>
                    <li>The right to delete your personal data (subject to legal obligations)</li>
                    <li>The right to withdraw consent at any time</li>
                </ul>
                <p className="text-lg text-gray-700 mt-4">
                    If you wish to exercise any of these rights, please contact us at <a href="mailto:support@nassfoods.com" className="text-blue-600">support@nassfoods.com</a>.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Third-Party Services</h2>
                <p className="text-lg text-gray-700">
                    We may use third-party services, such as payment processors and analytics providers, that may have access to your personal data. These third parties are obligated not to disclose or use your information for any other purpose than to assist us in providing our services.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Changes to This Policy</h2>
                <p className="text-lg text-gray-700">
                    We may update this Privacy Policy from time to time. When we do, we will post the revised policy on this page and update the effective date. We encourage you to review this policy periodically to stay informed about how we are protecting your information.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
                <p className="text-lg text-gray-700">
                    If you have any questions or concerns about this Privacy Policy, please contact us at:
                </p>
                <address className="text-lg text-gray-700 mt-4">
                    NassFoods<br />
                    Email: <a href="mailto:support@nassfoods.com" className="text-blue-600">support@nassfoods.com</a><br />
                </address>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
